import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";
import pisoHeaderReport from "./PisoHeaderReport";
import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";

export default async function pisoReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const additionalColumn = (indicador.type.field === "plantio" || indicador.type.field === "colheitas")
            ? {
                label: "Operador",
                field: "operador.operador",
                width: "*"
            }
            : undefined;

        content.push([
            await apontamentoHeaderLocalizacaoReport(visita, indicador, apontamento, params, undefined, undefined, additionalColumn),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Ruas Avaliadas", "Ruas com Pisoteio", "Pisoteio (%)"],
                // prettier-ignore
                (h) => [
                    h.textField("ruasAvaliadas"),
                    h.textField("ruasComPisoteio"),
                    h.numberField("pisoteio"),
                ],
                [60, 60, 60]
            ),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
